import React, { Component, PropTypes } from 'react';
import { ParameterType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import Checkbox from 'components/CheckboxControl';
import { arrayContainsValue } from 'core/utils.js';
import ParamConstants from 'constants/Parameters';
import ParametersStore from 'stores/ParametersStore';
import IconSVG from 'svg-inline-react';

import './TruckBodyTypePane.scss';

class TypeAllControl extends Component {

    static propTypes = {
        label: PropTypes.string.isRequired,
        parameter: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
    }

    render() {
        var valueLength = (this.props.parameter.value ? this.props.parameter.value.length : 0);
        var checked = (valueLength == Object.keys(this.props.parameter.values).length);

        return (
            <Checkbox className="AllControl" type="checkbox" label={ this.props.label } name={ this.props.label }
                      value={ checked }
                      onChange={ this.handlerChange } />
        );
    }

    handlerChange = (e) => {
        var checked = e.target.checked;
        var list = [];
        var params = ParametersStore.getDeliveryParameters(); //params store set

        if (checked) {
            for (var id in this.props.parameter.values) {
                if (this.props.parameter.values.hasOwnProperty(id)) {
                    switch (this.props.parameter.name) {
                        case 'truck_body_type_open':
                            if (id == ParamConstants.TRUCK_BODY_TYPE_OPEN.BOARD ||
                                id == ParamConstants.TRUCK_BODY_TYPE_OPEN.SHALANDA ||
                                id == ParamConstants.TRUCK_BODY_TYPE_OPEN.OPEN_TOP) {
                                    list.push(this.props.parameter.values[id].id);
                            } else {

                                for (var pid in params[this.props.parameter.name].value) {
                                    if (id == params[this.props.parameter.name].value[pid]) {
                                        list.push(this.props.parameter.values[id].id);
                                    }
                                }
                            }
                            break;
                        default:
                            list.push(this.props.parameter.values[id].id);
                            break;
                    }
                }
            }
        }

        var parameter = {};
        parameter[this.props.parameter.name] = list;

        ActionCreators.updateParameter(parameter);
    }
}

class TypeControl extends Component {

    static propTypes = {
        parameter: PropTypes.object.isRequired,
        valueId: PropTypes.number.isRequired
    }

    constructor(props) {
        super(props);
    }

    render() {
        const checked = arrayContainsValue(this.props.parameter.value, [this.props.valueId]);

        return (
            <div className="TypeControl-GroupItem">
                <Checkbox type="checkbox" label={ this.props.parameter.values[this.props.valueId].value } name={ this.props.valueId }
                          value={ checked }
                          onChange={ this.handlerChange }/>
            </div>
        );
    }

    handlerChange = (e) => {
        var id = parseInt(e.target.name);
        var checked = e.target.checked;
        var list = (this.props.parameter.value ? this.props.parameter.value.slice(0) : []);

        if (checked) {
            list.push(id);
        } else {
            var index = list.indexOf(id);
            if (index >= 0) list.splice(index, 1);
        }

        var parameter = {};
        parameter[this.props.parameter.name] = list;

        ActionCreators.updateParameter(parameter);
    }
}

class PopularTypes extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        var parameters = this.props.parameters;

        var allOpened = null;
        if (parameters['truck_body_type_open']) {
            allOpened = <TypeAllControl label="Любой открытый" parameter={ this.props.parameters['truck_body_type_open'] } />;
        }

        var allClosed = null;
        if (parameters['truck_body_type_close']) {
            allClosed = <TypeAllControl label="Любой закрытый" parameter={ this.props.parameters['truck_body_type_close'] } />;
        }

        var allTemp = null;
        if (parameters['truck_body_type_temp']) {
            allTemp = <TypeAllControl label="Температурные" parameter={ this.props.parameters['truck_body_type_temp'] } />;
        }

        var allOutsized = null;
        if (parameters['truck_body_type_outsized']) {
            allOutsized = <TypeAllControl label="Негабарит" parameter={ this.props.parameters['truck_body_type_outsized'] } />;
        }

        var allPassengers = null;
        if (parameters['truck_body_type_passenger']) {
            allPassengers = <TypeAllControl label="Пассажирские" parameter={ this.props.parameters['truck_body_type_passenger'] } />;
        }

        var opened53 = null;
        if (parameters['truck_body_type_open'] && parameters['truck_body_type_open'].values[ParamConstants.TRUCK_BODY_TYPE_OPEN.TIPPER]) {
            opened53 = (
                <TypeControl
                    parameter={ parameters['truck_body_type_open'] }
                    valueId={ ParamConstants.TRUCK_BODY_TYPE_OPEN.TIPPER } />
            );
        }

        return (
            <div className="PopularTypesPane">
                { allOpened }
                { allClosed }
                { allTemp }
                { allOutsized }
                { allPassengers }
                { opened53 }
            </div>
        );
    }

}

class AllTypes extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired
    }

    constructor(props) {
        super(props);
    }

    renderValues = (parameter) => {
        var list = [];

        for (var id in parameter.values) {
            if (!parameter.values.hasOwnProperty(id)) continue;
            list.push(
                <TypeControl
                    key={ id }
                    parameter={ parameter }
                    valueId={ parameter.values[id].id } />
            );
        }
        return list;
    }

    render() {
        var parameters = this.props.parameters;

        var openedGroup = null;
        if (parameters['truck_body_type_open']) {
            openedGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Открытые</div>
                    { this.renderValues(parameters['truck_body_type_open']) }
                </div>
            );
        }
        var closedGroup = null;
        if (parameters['truck_body_type_close']) {
            closedGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Закрытые</div>
                    { this.renderValues(parameters['truck_body_type_close']) }
                </div>
            );
        }

        var tempGroup = null;
        if (parameters['truck_body_type_temp']) {
            tempGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Температурные</div>
                    { this.renderValues(parameters['truck_body_type_temp']) }
                </div>
            );
        }

        var outsizedGroup = null;
        if (parameters['truck_body_type_outsized']) {
            outsizedGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Негабарит</div>
                    { this.renderValues(parameters['truck_body_type_outsized']) }
                </div>
            );
        }

        var passengersGroup = null;
        if (parameters['truck_body_type_passenger']) {
            passengersGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Пассажирские</div>
                    { this.renderValues(parameters['truck_body_type_passenger']) }
                </div>
            );
        }

        var otherGroup = null;
        if (parameters['truck_body_type_other']) {
            otherGroup = (
                <div className="AllTypesPane-Group">
                    <div className="AllControlDiv">Прочие</div>
                    { this.renderValues(parameters['truck_body_type_other']) }
                </div>
            );
        }

        return (
            <div className="AllTypesPane">
                <div className="AllTypesPane-Title">Все типы кузовов</div>
                <div className="AllTypesPane-Block">
                    <div>
                        { openedGroup }
                        { closedGroup }
                    </div>
                    <div>
                        { tempGroup }
                        { outsizedGroup }
                        { passengersGroup }
                    </div>
                    { otherGroup }
                </div>
                <div className="AllTypesPane__end"></div>
            </div>
        )
    }

}

class TruckBodyTypePane extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            showAllTypes: false
        };
    }

    render() {
        var switcherTitle = (this.state.showAllTypes ? "Только популярные" : "Все типы кузовов");
        var switcherArrowLink = (this.state.showAllTypes ? "arrow_up.svg" : "arrow_down.svg");

        var allTypes = null;
        if (this.state.showAllTypes) allTypes = <AllTypes parameters={ this.props.parameters }/>;

        return (
            <div className="TruckBodyTypePane">
                <PopularTypes parameters={ this.props.parameters }/>
                { allTypes }
                <div className="AllTypesSwitcher" onClick={ this.handlerSwitchAllTypes }>
                    <div className="AllTypesSwitcher__title">{ switcherTitle }</div>
                    <div className="AllTypesSwitcher__arrow"><IconSVG src={require('!svg-inline!./' + switcherArrowLink)}/></div>
                </div>
            </div>
        );
    }

    handlerSwitchAllTypes = () => {
        this.setState({ showAllTypes: !this.state.showAllTypes });
    };
}

export default TruckBodyTypePane;



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/TruckBodyTypePane.js